<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>STOCK DE MATERIALES EN DEPÓSITO</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listadoP" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title center>
                            <font color="green"> Actualizados</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="black" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verP(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>Ver</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <v-data-table dense :headers="headers" :items="listadoV" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title center>
                            <font color="green"> Fecha de Actualización vencida</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="black" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verP(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>Ver</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <Ver :visible="showVer" :doc="editedItem.ruta" @close="showVer = false">
            </Ver>
        </v-app>
    </div>
</template>


<script>
import axios from "../../axios-auth";
import Ver from "../Deposito/Visualizadorxls.vue";
import moment from "moment";

export default {
    components: { Ver },
    data: (vm) => ({
        usuario: "",
        editedItem: {
            descr: "",
            fecha: "",
            ruta: "",
        },
        editedIndex: -1,
        listadoP: [],
        listadoV: [],
        showVer: false,
        loadtable: false,
        headers: [
            { text: "Material", value: "descr", sortable: false },
            { text: "Fecha última actualización", value: "fecha", sortable: false },
            { text: "Ver Archivo", value: "actions", align: "center", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                //this.usuario = this.$store.state.nombre.toString().trim();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            let self = this;
            axios
                .get("/Icssa/ListadoStock?", {
                })
                .then((response) => {
                    response.data.forEach(element => {
                        if (moment(element.fecha, "DD/MM/YYYY").isBefore(moment().subtract(1, 'months'))) {
                            self.listadoV.push(element);
                        }
                        else {
                            self.listadoP.push(element);
                        }
                    });
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listadoP = [];
                    console.log(error);
                });
        },
        verP(item) {
            this.editedIndex = this.listadoP.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showVer = true;
        },

        vaciarModels() {
            this.listadoP = [];

        },
    },
};
</script>
